module.exports = __webpack_public_path__ + "media/images/pro_subscription/carousel3-haircut-en-GB@2x-684acd3d10792ade05eaa4414bfd2718.png";